<template>
  <v-timeline dense align-top>
    <v-timeline-item
      v-for="item in history"
      :key="item.id"
      :color="color"
      small
    >
      <div class="flex-row-center">
        <poptip-profile
          :gid="item.gid"
          :useremail="item.useremail"
          :username="
            item.fullName.length > 15
              ? item.fullName.split(' ')[0]
              : item.fullName
          "
          :url="item.thumbnailPhotoUrl"
          :avatarsize="16"
          :textsize="14"
          :prefix="item.timestamp"
        />
      </div>
      <div
        class="pl-4 pr-2 mt-2 font-weight-light"
        style="font-size: 1rem; display: -webkit-box;-webkit-box-orient: vertical; overflow: hidden;"
      >
        <div v-if="item.comments">
          <v-hover v-slot:default="{ hover }">
            <div>
              {{ item.action }}
              <div
                style="color: #00CAE3; word-wrap:break-word; word-break:break-all;"
              >
                {{ "Comments: " + item.comments }}
              </div>
            </div>
          </v-hover>
        </div>
        <div v-else-if="item.pdfName">
          <v-hover v-slot:default="{ hover }">
            <div>
              {{ item.action }}
              <div
                style="color: #00CAE3; word-wrap:break-word; word-break:break-all;"
              >
                <md-icon>link</md-icon>
                <a target="_blank" :href="item.pdfName">Open Letter</a>
              </div>
            </div>
          </v-hover>
        </div>
        <span v-else>
          {{ item.action }}
        </span>
      </div>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import { mapState } from "vuex";
import { EventBus } from "@/components/eventBus.js";

export default {
  name: "History",

  components: {
    PoptipProfile: () => import("@/components/poptip-profile")
  },

  props: {
    token: {
      type: String,
      default() {
        return "";
      }
    },
    hasAccess: {
      type: Boolean,
      default() {
        return true;
      }
    },
    history: {
      type: Array,
      default() {
        return [];
      }
    },
    members: {
      type: Array,
      default() {
        return [];
      }
    },
    color: {
      type: String,
      default: "primary"
    },
    requestEmail: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      ttt: [],
      comment: "",
      // memberslist: [],
      searchText: "",
      mentionedArr: []
    };
  },

  computed: {
    ...mapState(["userInfo"])
    // memberslist () {
    //   const arr = this.members
    //   let r = []
    //   if (this.searchText) {
    //     console.info(this.searchText)
    //     r = arr.filter(el => el.fullName.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1)
    //     return r
    //   } else {
    //     r = arr
    //     console.info(r)
    //     return r
    //   }
    // },
  },

  // async mounted () {
  //   this.memberslist = this.members
  // },

  methods: {
    look() {
      console.info(this.comment);
      if (this.comment) {
        EventBus.$emit("showSnackbar", { color: "success", msg: this.comment });
      }
      this.finalMentioned(this.comment);
    },
    finalMentioned(comment) {
      try {
        const arr = this.mentionedArr
          .filter(el => comment.indexOf("@" + el.fullName) > -1)
          .map(el => el.useremail);
        const sText = arr.join(", ");
        return sText;
      } catch (err) {
        return "";
      }
    },
    handleInsert(item) {
      if (item.useremail) {
        const inx = this.mentionedArr.findIndex(
          el => el.useremail === item.useremail
        );
        if (inx === -1) {
          console.info("inserted: ", item);
          this.mentionedArr.push(item);
          console.info(this.mentionedArr);
        }
      }
    },
    async fetchFromRemote(val) {
      if (val && val.length > 2 && val === this.searchText) {
        try {
          let result = [];
          const gapi = await this.$gapi.getGapiClient();
          const response = await gapi.client.directory.users.list({
            viewType: "domain_public",
            customer: "my_customer",
            maxResults: 10,
            orderBy: "email",
            domain: "nielsen.com",
            query: val.toString().trim()
          });
          if (response.status === 200) {
            result = response.result.users || [];
            result.map(el => ({
              useremail: el.primaryEmail,
              fullName: el.name.fullName,
              thumbnailPhotoUrl: el.thumbnailPhotoUrl || null,
              gid: el.id
            }));
            return result;
          }
        } catch (e) {
          return [];
        }
      }
    }
  }
};
</script>

<style></style>
